import validate from '../../../services/reduxValidate.js'

export default function (data) {
  const constraints = {
    'freelance.date_available': {isoDate: true}
  }

  if (data.user && data.user.cdi) {
    constraints['user.cdi_start'] = {
      isoDate: true,
      presence: {
        allowEmpty: false
      }
    }
  }

  const errors = {
    user: {}
  }
  if (data.freelance.public && !data.user.complete) {
    errors.user.complete = { _error: 'Le user doit être complet pour pouvoir être public.' }
  }

  return { ...validate(data, constraints), ...errors}
}